import axios from '@axios'

export default {
  namespaced: true,
  state: {
    calendarOptions: [
      {
        color: 'primary',
        label: 'Tâche',
      },
      {
        color: 'warning',
        label: 'Rendez-vous',
      }
    ],
    selectedCalendars: ['Tâche', 'Rendez-vous'],
    checkAllUsersCalendars: 'Own'
  },
  getters: {},
  mutations: {
    SET_SELECTED_EVENTS(state, val) {
      state.selectedCalendars = val
    },
    checkAllUsers(state, val) {
      state.checkAllUsersCalendars = val
    },
  },
  actions: {
    fetchEvents(ctx, { calendars }) {
      return new Promise((resolve, reject) => {
        axios
          .get('/calendar/events', {
            params: {
              calendars: calendars.toString(),
              checkAllUsers: ctx.state.checkAllUsersCalendars
            },
          })
          .then(response => {
            resolve(response)})
          .catch(error => reject(error))
      })
    },
    addEvent(ctx, { event }) {
      return new Promise((resolve, reject) => {
        axios
          .post('/calendar/events', { event })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateEvent(ctx, { event }) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/calendar/events/${event.id}`, { event })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    removeEvent(ctx, { event }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/calendar/events/${event.id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

  },
}
